"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)};
